import { render, staticRenderFns } from "./GalleryCategoryTable.vue?vue&type=template&id=556bf6b8&"
import script from "./GalleryCategoryTable.vue?vue&type=script&lang=js&"
export * from "./GalleryCategoryTable.vue?vue&type=script&lang=js&"
import style0 from "./GalleryCategoryTable.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports